import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import customersClient from '@clients/customersClient';
import dontRetry404 from '@utils/dontRetry404';
import is404Response from '@utils/is404Response';
import notifyAPIError from '@utils/notifyAPIError';

const { getCustomerCards } = customersClient();

const useGetCustomerCards = (accountId: number, customerId: number) => {
    const { data, error, isLoading, isError, refetch } = useQuery(
        ['getCustomerCards', customerId, accountId],
        () => getCustomerCards({ accountId, customerId }),
        {
            enabled: !!accountId && !!customerId,
            onError: (error: unknown) => {
                if (!is404Response((error as AxiosError).response)) {
                    notifyAPIError(error);
                }
            },
            retry: dontRetry404,
        },
    );

    return { data, error, isLoading, isError, refetch };
};

export default useGetCustomerCards;
